import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Breadcrumb,
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup
} from 'react-bootstrap'

import Collapsible from '../collapsible'

@observer(['globals', 'users'])
export default class Profile extends Component {
  constructor(props) {
    super(props)

    this.state = {
      userId: localStorage.getItem('userId'),
      prevFirstName: localStorage.getItem('userFirstName'),
      prevLastName: localStorage.getItem('userLastName'),
      prevEmail: localStorage.getItem('userEmail'),
      firstName: localStorage.getItem('userFirstName'),
      lastName: localStorage.getItem('userLastName'),
      email: localStorage.getItem('userEmail'),
      newPassword: ''
    }
  }

  firstNameChanged(e) {
    this.setState({
      firstName: e.target.value
    })
  }

  lastNameChanged(e) {
    this.setState({
      lastName: e.target.value
    })
  }

  emailChanged(e) {
    this.setState({
      email: e.target.value
    })
  }

  passwordChanged(e) {
    this.setState({
      newPassword: e.target.value
    })
  }

  saveProfile(e) {
    let profile = {
      id: this.state.userId,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email
    }

    if (this.state.newPassword != '') {
      profile.password = this.state.newPassword
    }

    this.props.users.updateProfile(profile)
  }

  render() {

    const profileContent = (
      <Form>
        <FormGroup>
          <Col sm={ 6 }>
            <FormGroup>
              <ControlLabel>Username</ControlLabel>
              <FormControl type="text" id="profileUsername" disabled value={ localStorage.getItem('userName') } />
            </FormGroup>
          </Col>
          <Col sm={ 6 }>
            <FormGroup>
              <ControlLabel>Password</ControlLabel>
              <FormControl type="password" id="profilePassword" placeholder="New Password" value={ this.state.newPassword } onChange={ this.passwordChanged.bind(this) } />
            </FormGroup>
          </Col>
          <Col sm={ 6 }>
            <FormGroup>
              <ControlLabel>First Name</ControlLabel>
              <FormControl type="text" id="profileFirstName" placeholder="First Name" value={ this.state.firstName } onChange={ this.firstNameChanged.bind(this) }/>
            </FormGroup>
          </Col>
          <Col sm={ 6 }>
            <FormGroup>
              <ControlLabel>Last Name</ControlLabel>
              <FormControl type="text" id="profileLastName" placeholder="Last Name" value={ this.state.lastName } onChange={ this.lastNameChanged.bind(this) } />
            </FormGroup>
          </Col>
          <Col sm={ 6 }>
            <FormGroup>
              <ControlLabel>Email</ControlLabel>
              <FormControl type="text" id="profileEmail" placeholder="Email" value={ this.state.email } onChange={ this.emailChanged.bind(this) } />
            </FormGroup>
          </Col>
        </FormGroup>
        <FormGroup>
          <Col sm={ 12 }>
            <Button bsStyle="success" onClick={ this.saveProfile.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Col>
        </FormGroup>
      </Form>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Profile</Breadcrumb.Item>
            </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          <Collapsible title="Profile" content={ profileContent } />
        </div>
        <div style={{ clear: 'both' }}></div>
      </div>
      )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/profile.js